import '~/js/sections/weddings/includes/scroll-below';
import '~/js/sections/weddings/includes/destinations.js';
import '~/js/sections/weddings/includes/enhancementIdeas.js';

// create new array for countries and appending a new object that represents default value
const countries = [
    {
      name: 'Select a Country',
      id: '',
      regionCode: '',
      code: ''
    },
    ...window.beaches_app.page.countries
  ];
  
  // create new array for states and appending a new object that represents default value
  const states = [
    ...window.beaches_app.page.states
  ];
  
  import CustomDatePicker from '~/js/components/form-controls/CustomDatePicker';
  import CountryStateSelector from '~/js/components/form-controls/CountryStateSelector';
  import FileImageUpload from '~/js/components/form-controls/FileImageUpload';
  import CustomRecaptcha from '~/js/components/form-controls/CustomRecaptcha';
  import { PhoneCodeToggler } from '~/js/modules/gcv/phone-code-toggler';
  import countryPhoneCodes from '~/js/modules/country-phone-codes';
  
  ReactDOM.render(
    <CountryStateSelector
      countries={ countries }
      states={ states }
      countryName="countryCode"
      stateName="state"
      stateLabelWrapper="lg-5"
      stateInputWrapper="xs-12"
      countryLabelWrapper="lg-5"
      countryInputWrapper="xs-12"
    />,
    document.getElementById('country-state-selector-1')
  );
  
  ReactDOM.render(
    <CountryStateSelector
      countries={ countries }
      states={ states }
      countryName="agencyCountry"
      stateName="guestState"
      stateLabelWrapper="lg-5"
      stateInputWrapper="xs-12"
      countryLabelWrapper="lg-5"
      countryInputWrapper="xs-12"
    />,
    document.getElementById('country-state-selector-2')
  );
  
  ReactDOM.render(
    <CustomDatePicker
      name="checkInDate"
      inputClassName="checkin-date-input"
      isRequired
      displayPlaceHolder
      displayStringDate={false}
    />,
    document.getElementById('checkin-datepicker')
  );
  
  ReactDOM.render(
    <FileImageUpload
      fileSizeLimit={ 3 }
      isRequired
      name="document"
      btnMessage="CHOOSE FILE"
      displaySelectedFileName
    />,
    document.getElementById('upload-file')
  );
  
  ReactDOM.render(
    <CustomRecaptcha
      wrapperClassName="xs-12 lg-12"
    />,
    document.getElementById('google-recaptcha')
  );
  
  // form validations
  import '~/js/modules/fend';
  
  // form elements references
  // const $landlineNumber = $('#landLineNumber');
  // const $mobileNumber = $('#mobileNumber');
  // const $guestLandLineNumber = $('#guestLandLineNumber');
  // const $guestMobileNumber = $('#guestMobileNumber');
  const $resortSelect = $('select[name="resort"]');
  const $checkInDate = $('input[name="checkInDate"]');
  const $submitButton = $('#submit-button');
  const $freeAnniversaryForm = $('#free-anniversary-form');
  
  // Form Validation
  $freeAnniversaryForm.fend({
    rules: {
      firstName: 'lettersOnly',
      lastName: 'lettersOnly',
      bookingNumber: 'alphanumeric',
      city: 'lettersOnly',
      state: 'lettersOnly',
      guestFirstName: 'lettersOnly',
      guestLastName: 'lettersOnly',
    },
    isMultiPart: true
  });

  const smsProp = document.querySelector(".sms");
  const countryInput = document.querySelector("#gcvCountryFieldId");
  const smsCheckBox = document.querySelector("#subscribeSms");

  countryInput.addEventListener("change", function(event){
  
    if(event.target.value === "US"){
      smsProp.classList.remove("hideSms");
      smsProp.classList.add("showSms");
    }
    else if(event.target.value !== "US"){
      smsProp.classList.add("hideSms");
      smsProp.classList.remove("showSms");

      if(smsCheckBox.checked===true){
        smsCheckBox.checked = false;
      }
    }
  })

  
  // Phone number validations
  // $landlineNumber.on('input', function validateNumber() {
  //   if (this.value) {
  //     $mobileNumber.removeAttr('required');
  //     $mobileNumber.trigger( 'blur' );
  //   }else {
  //     $mobileNumber.attr('required', true);
  //   }
  // });
  
  // $mobileNumber.on('input', function validateNumber() {
  //   if (this.value) {
  //     $landlineNumber.removeAttr('required');
  //     $landlineNumber.trigger( 'blur' );
  //   }else {
  //     $landlineNumber.attr('required', true);
  //   }
  // });
  
  // $guestLandLineNumber.on('input', function validateNumber() {
  //   if (this.value) {
  //     $guestMobileNumber.removeAttr('required');
  //     $guestMobileNumber.trigger( 'blur' );
  //   }else {
  //     $guestMobileNumber.attr('required', true);
  //   }
  // });
  
  // $guestMobileNumber.on('input', function validateNumber() {
  //   if (this.value) {
  //     $guestLandLineNumber.removeAttr('required');
  //     $guestLandLineNumber.trigger( 'blur' );
  //   }else {
  //     $guestLandLineNumber.attr('required', true);
  //   }
  // });
  
  $submitButton.click( () => {
    const $actualResort = $resortSelect.val();
    const $actualDate = $checkInDate.val();
  
    $freeAnniversaryForm.attr('data-location', '/anniversaries/free/thankyou/?resortName=' + $actualResort + '&checkInDate=' + $actualDate);
  });
  
  $(document).ready(() => {
    const phoneTogglerOpts = {
      countryInput: '[name=countryCode]',
      countryCodeLabel: 'span.countryCode',
      phoneCodes: countryPhoneCodes
    };
  
    const countryCodeHandler = new PhoneCodeToggler(phoneTogglerOpts);
  
    countryCodeHandler.init();
  
    const phoneTogglerOptsTA = {
      countryInput: '[name=agencyCountry]',
      countryCodeLabel: 'span.countryCodeTA',
      phoneCodes: countryPhoneCodes
    };
  
    const taCountryCodeHandler = new PhoneCodeToggler(phoneTogglerOptsTA);
  
    taCountryCodeHandler.init();
  });
  